import axios from "axios";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import ComplaintBookDataSource from "../ComplaintBookDataSource";
import { ComplaintBookAPIEntity, ExtensionAPIEntity } from "./Entity/ComplaintBookAPIEntity";
import { ComplaintBooksAPIEntity } from "./Entity/ComplaintBooksAPIEntity";

const routeName = `/v1/ComplaintBook`;

export class ComplaintBookAPIDataSourceImpl implements ComplaintBookDataSource {

    async getComplaintBooks(page: number, pageSize: number, search: string): Promise<PaginationResult<ComplaintBooksAPIEntity>> {
        try {
            const response = await api.get<ApiResponse<any>>(routeName, {
                params: { page, pageSize, search },
            });
            // console.log(response.data.data);
            const data = response.data.data;

            if (data && Array.isArray(data.items)) {
                const complaintBooks: ComplaintBooksAPIEntity[] = data.items.map((item: ComplaintBooksAPIEntity) => ({
                    id: item.id,
                    name: item.name,
                    paternalLastName: item.paternalLastName,
                    maternalLastName: item.maternalLastName,
                    documentType: item.documentType,
                    documentNumber: item.documentNumber,
                    email: item.email,
                    department: item.department,
                    claimType: item.claimType,
                    created: item.created
                }));

                return {
                    items: complaintBooks,
                    page: data.page,
                    pageSize: data.pageSize,
                    totalCount: data.totalCount,
                    hasNextPage: data.hasNextPage,
                    hasPreviousPage: data.hasPreviousPage,
                };
            } else {
            // Maneja el caso en el que la respuesta no tiene el formato esperado
            throw new Error("La respuesta no tiene el formato esperado");
            }
        } catch (error) {
            // Maneja errores de solicitud
            console.error("Error al obtener los registros de reclamaciones:", error);
            throw new Error("Error al obtener los registros de reclamaciones");
        }
    }

    async getComplaintBooksById(id: number): Promise<ComplaintBookAPIEntity | null> {
        try {
            const response = await api.get<ApiResponse<ComplaintBookAPIEntity>>(`${routeName}/${id}`, {
            headers: { 'Content-Type': 'application/json' }
            });

            // Verificamos la estructura esperada
            if (!response.data?.data) {
            console.warn("La respuesta no contiene datos válidos");
            return null;
            }

            const complaintBook = response.data.data;
            const extension = complaintBook.extension;

            // Si existe extensión, la construimos con seguridad
            const extensionData: ExtensionAPIEntity | undefined = extension
            ? {
                representativeName: extension.representativeName,
                documentType: extension.documentType,
                documentNumber: extension.documentNumber,
                representativeAddress: extension.representativeAddress,
                representativePhoneNumber: extension.representativePhoneNumber,
                representativeEmail: extension.representativeEmail,
                }
            : undefined;

            // Construimos el objeto principal
            const complaintBookData: ComplaintBookAPIEntity = {
            id: complaintBook.id,
            documentType: complaintBook.documentType,
            documentNumber: complaintBook.documentNumber,
            name: complaintBook.name,
            paternalLastName: complaintBook.paternalLastName,
            maternalLastName: complaintBook.maternalLastName,
            email: complaintBook.email,
            phoneNumber: complaintBook.phoneNumber,
            phoneNumberType: complaintBook.phoneNumberType,
            address: complaintBook.address,
            purchaseItemType: complaintBook.purchaseItemType,
            serviceChannelType: complaintBook.serviceChannelType,
            amount: complaintBook.amount,
            description: complaintBook.description,
            subjectType: complaintBook.subjectType,
            claimType: complaintBook.claimType,
            detail: complaintBook.detail,
            request: complaintBook.request,
            isMinor: complaintBook.isMinor,
            supplierDetails: complaintBook.supplierDetails,
            extension: extensionData
            };

            return complaintBookData;

        } catch (error) {
            console.error("Error al obtener el libro de reclamaciones:", error);
            if (axios.isAxiosError(error)) {
            console.error("Detalles del error:", error.response?.status, error.response?.data);
            }
            return null;
        }
    }
}